module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [(_vm.panelFlag) ? _c('div', {}) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar'), _vm._v(" "), _c('sidebar')], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b02a9ac"}!./src/components/CNInsuranceSystem/CNInsurance/template.html
// module id = 311
// module chunks = 0